import React from "react";
import { Price } from "./styles";

interface FormattedNumberProps {
  value: number;
}

export const FrmttdPrc: React.FC<FormattedNumberProps> = ({ value }) => {
  const formatNumber = (num: number): string => {
    return num.toString().replace(/\B(?=(\d{3})+(?!\d))/g, " ");
  };

  return <Price>{formatNumber(value)} ₽</Price>;
};
